<template>
  <div class="pipe-list bg-transparent rounded-2px z-99 w-full h-full pt-10px">
    <div class="search-wrap flex items-center">
      <el-select
        v-model="searchData.deviceName"
        size="small"
        class="ml-5px"
        ref="fatherNode"
        popper-class="visualization-select-popper"
        placeholder="请选择装置"
        filterable
      >
        <el-input
          placeholder="此处输入关键词搜索查询"
          prefix-icon="el-icon-search"
          v-model="treeFilterKey"
          size="mini"
          clearable
        ></el-input>
        <el-option
          hidden
          key="id"
          :label="searchData.deviceName"
          :value="searchData.deviceName"
        ></el-option>
        <el-tree
          v-loading="deviceTreeLoading"
          ref="smallTreeDom"
          :data="treeData"
          empty-text="暂无数据"
          highlight-current
          :props="defaultTreeProps"
          :expand-on-click-node="false"
          :default-expand-all="false"
          :filter-node-method="filterTreeNode"
          @node-click="treeSelect"
          class="device-tree text-14px"
        >
        </el-tree>
      </el-select>
      <el-input
        size="small"
        v-model="keyWord"
        placeholder="请输入管道编码"
        clearable
        class="ml-5px"
      ></el-input>
      <el-button @click="searchHandler" size="mini" type="primary" class="ml-5px">搜索</el-button>
    </div>
    <el-table
      ref="markerTable"
      :data="tableData"
      class="markerTable mt-10px"
      height="calc(100% - 80px)"
      :cell-style="{ 'text-align': 'center' }"
      :header-cell-style="{ 'text-align': 'center' }"
      highlight-current-row
      @row-click="checkDetail"
      v-loading="tableLoading"
    >
      <el-table-column show-overflow-tooltip prop="code" label="管道编码"></el-table-column>
      <el-table-column show-overflow-tooltip prop="name" label="管道名称"></el-table-column>
    </el-table>
    <el-pagination
      small
      background
      @current-change="getTableData"
      :current-page.sync="page.pageNo"
      :page-size="page.pageSize"
      layout="total, prev, pager, next"
      :total="page.total"
      :pager-count="5"
      class="flex justify-end mt-10px"
    ></el-pagination>
  </div>
</template>

<script>
import { filter } from 'lodash'
import { ThreeDimensionsApi } from '@wiz-api/guang-xi-shi-hua'
import { ModelApi } from '@wiz-api/material-management'
import { FileApi } from '@wiz-api/file-management'

const modelApi = new ModelApi()
const fileApi = new FileApi()
const threeDimensionsApi = new ThreeDimensionsApi()

export default {
  components: {},
  props: {
    player: {
      type: Object,
      default: () => {
        return {}
      },
    },
    deviceInfo: {
      type: Object,
      defalut: () => {
        return {
          deviceName: null,
          deviceId: null,
          modelId: null,
        }
      },
    },
  },
  data() {
    return {
      tableLoading: false,
      keyWord: null,
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      tableData: [],

      searchData: {
        deviceName: null,
      },
      treeFilterKey: null,
      deviceTreeLoading: false,
      treeData: [], // 装置treeData
      defaultTreeProps: {
        children: 'children',
        label: 'deviceName',
      },
      currentDeviceId: null, // 当前装置id
      currentModelId: null, // 当前的模型id
    }
  },
  watch: {},
  computed: {
    // 广西石化管线类别代码
    gxPipeClassCode() {
      return Wiz.globalSettings.globalConfig?.gxPipeClassCode || 'A06_0601'
    },
    // 模型相关设置
    modelSetting() {
      return (
        Wiz.globalSettings.globalConfig?.modelSetting ||
        _.get(Wiz, 'globalSettings.dynamicModules.modules["visualization-cockpit"].config')
          ?.modelSetting ||
        {}
      )
    },
  },
  async created() {
    this.getDeviceList()
  },
  beforeDestroy() {
    this.player.Native.Node.unSelectNodes([])
  },
  methods: {
    // 装置树检索
    filterTreeNode(value, data) {
      if (!value) return true
      return data.deviceName.indexOf(value) !== -1
    },
    // 装置树选择
    treeSelect(data) {
      if (!data.modelId) {
        this.$message.warning('该装置未绑定模型')
        return
      }
      if (this.currentDeviceId === data.id) {
        console.log('same device')
        return
      }
      this.$emit('loadingSwitch', { bol: true, title: '正在切换装置' })
      this.player.Native.Node.EventLoadFileFinish.connect(this.checkModelLoadEnd)
      this.searchData.deviceName = data.deviceName
      this.currentDeviceId = data.id
      this.currentModelId = data.modelId
      this.$emit('updateDeviceInfo', {
        deviceName: data.deviceName,
        deviceId: data.id,
        modelId: data.modelId,
      })
      this.$refs.fatherNode.blur()
      this.resetData()
      this.getModelDetail() // 获取模型详情
      this.searchHandler() // 获取管线列表
    },
    // 获取装置下拉列表
    async getDeviceList() {
      this.deviceTreeLoading = true
      const [err, res] = await threeDimensionsApi.getDeviceList({
        isTree: true,
        body: {
          name: null,
        },
      })
      this.deviceTreeLoading = false
      if (!err && res) {
        const filterTree = (nodes) => {
          const filterNode = (node) => {
            if (!node.modelId) {
              return null
            }
            if (node.children && node.children.length > 0) {
              const filteredChildren = node.children.map(filterNode).filter((child) => {
                return child !== null
              })
              node.children = filteredChildren.length > 0 ? filteredChildren : []
            }

            return node
          }
          return nodes.map(filterNode).filter((node) => {
            return node !== null
          })
        }
        this.treeData = filterTree(res)
        if (res.length) {
          if (this.deviceInfo.deviceId) {
            this.searchData.deviceName = this.deviceInfo.deviceName
            this.currentDeviceId = this.deviceInfo.deviceId
            this.currentModelId = this.deviceInfo.modelId
          } else {
            this.searchData.deviceName = res[0].deviceName
            this.currentDeviceId = res[0].id
            this.currentModelId = res[0].modelId
          }
          this.searchData = Object.assign(this.searchData, {
            tagCode: null,
            medium: null,
          })
          // this.initDevice() // 初始化装置半透明
          this.searchHandler() // 获取全场管线数据
        }
      }
    },
    // 重置数据
    async resetData() {
      this.tableData = [] // 清空表单
    },
    // 获取模型详情信息
    async getModelDetail() {
      const [err, res] = await modelApi.get(this.currentModelId)
      if (!err && res?.medias) {
        const modelInfo = _.find(res.medias, ['mediaType', 1])
        const textureInfo = _.find(res.medias, ['mediaType', 2])
        console.log('获取切换模型详情', err, res)
        if (modelInfo?.fileInfoId) {
          // 获取模型文件详情，确定文件类型
          let fileType = 'pr'
          const [fileErr, fileRes] = await fileApi.get(modelInfo.fileInfoId)
          if (!fileErr && fileRes?.name) {
            fileType = _.last(fileRes.name.split('.')) || 'pr'
          }
          console.log('获取的文件详情', fileErr, fileRes)
          const modelDetail = {
            filePath: `data://../apps/${this.modelSetting.folderName}/models/${modelInfo.fileInfoId}/${modelInfo.fileInfoId}.${fileType}`,
            materialFileId: textureInfo ? textureInfo.fileInfoId : '',
            modelFileId: modelInfo.fileInfoId,
          }
          this.$emit('changeModel', modelDetail)
        } else {
          this.$message.warning('模型文件不存在')
        }
      }
    },
    // 获取管线表数据
    async getTableData() {
      // currentDeviceId
      const [err, res] = await threeDimensionsApi.getDeviceRelationPipeLineList({
        body: {
          pageNo: this.page.pageNo,
          pageSize: this.page.pageSize,
          deviceId: this.currentDeviceId,
          tagCode: this.keyWord ? `%${this.keyWord}%` : null,
        },
      })
      if (!err && res?.code && res.code === '200' && res.data?.items) {
        this.tableData = res.data.items.map((e) => {
          return {
            ...e,
            code: e.tagCode,
            name: e.tagName,
          }
        })
        this.page.total = res.data.totalCount
      }
    },
    // // 获取管线表数据
    // async getTableData() {
    //   this.tableLoading = true
    //   const [err, res] = await threeDimensionsApi.getTagList({
    //     body: {
    //       code: this.keyWord ? `%${this.keyWord}%` : null,
    //       pageNo: this.page.pageNo,
    //       pageSize: this.page.pageSize,
    //       classCode: this.gxPipeClassCode,
    //     },
    //   })
    //   this.tableLoading = false
    //   if (!err && res && res.code === '200' && res.data?.items) {
    //     this.tableData = res.data.items
    //     this.page.total = res.data.totalCount
    //   }
    // },
    // 搜索
    searchHandler() {
      this.page.pageNo = 1
      this.getTableData()
    },
    async checkDetail(row) {
      this.$emit('transferEvent', {
        toCom: { code: 'ValveList', origin: 'ValveManagement', name: '阀门列表' },
        type: 'mainComponent',
        props: {
          ...row,
        },
      })
      const rootNode = await this.player.Native.Node.getRoot()
      const codeData = await this.player.Native.Node.findNode(rootNode, {
        codes: [row.code],
      })
      console.log('通过位号找到的node信息', codeData)
      const codes = codeData?.codes
      if (codes && codes[row.code] && codes[row.code].node) {
        await this.player.Native.Node.unSelectNodes([])
        this.player.Native.Node.selectNodes([codes[row.code].node])
        // 计算节点包围盒
        const NodeInfo = await this.player.Native.Node.getProperty(codes[row.code].node, ['aabb'])
        // 相机移动到包围盒位置
        this.player.Native.Camera.moveToAabbWithFace(NodeInfo.aabb, 1, 25)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.search-wrap {
  ::v-deep .el-button {
    height: 28px !important;
    border-radius: 5px !important;
  }
  ::v-deep .el-input--small .el-input__inner {
    height: 28px !important;
    line-height: 28px !important;
  }
}
::v-deep {
  .el-table__empty-text {
    display: unset !important;
  }
  .el-table__empty-block::before {
    display: none;
  }
}
.markerTable {
  ::v-deep .el-checkbox {
    margin: 0 !important;
  }
  ::v-deep .el-table th.is-leaf,
  .el-table td {
    border: none !important;
  }
}
::v-deep {
  .el-pagination.is-background.el-pagination--small .btn-next,
  .el-pagination.is-background.el-pagination--small .btn-prev,
  .el-pagination.is-background.el-pagination--small .el-pager li {
    padding: 0 !important;
    margin: 0 3px !important;
  }
}
</style>
